import { createServiceAction } from '../util/actionHelper.js';
import { apiConfig } from '../configs/apiConfig.js';
import { getRequest } from '../util/index.js';
import { getHTTPStatusValidationMessage, getServerValidationMessage } from '../services/serverValidations.js';
import { put, takeEvery, call, select } from 'redux-saga/effects';

export function* listener(serviceType, action) {
  try {
    const { trf } = yield select(state => state);
    const isAlreadyLoaded = Array.isArray(trf && trf.labLocationCountries) && trf.labLocationCountries.length > 0;
    const isLoading = Boolean(trf && trf.labLocationsLoading);
    const shouldForceRefresh = Boolean(action && action.payload && action.payload.forceRefresh);

    if (!shouldForceRefresh && (isAlreadyLoaded || isLoading)) {
      return;
    }

    yield put(createServiceAction(serviceType, 'loading')());

    const availableOnly = action && action.payload ? action.payload.availableOnly !== false : true;
    const endPointUrl = availableOnly
      ? apiConfig.getLabLocations.endPointUrl
      : `${apiConfig.getLabLocations.endPointUrl}?availableOnly=false`;
    const res = yield call(getRequest, endPointUrl);
    const statusErrorMessage = yield call(getHTTPStatusValidationMessage, res);
    if (statusErrorMessage) {
      yield put(createServiceAction(serviceType, 'error')(statusErrorMessage));
      return;
    }

    const response = yield res.json();
    const serverErrorMessage = yield call(getServerValidationMessage, response);
    if (serverErrorMessage || response.errorCode !== 0) {
      yield put(createServiceAction(serviceType, 'error')(serverErrorMessage || response));
      return;
    }

    yield put(createServiceAction(serviceType, 'success')(response));
  } catch (e) {
    yield put(createServiceAction(serviceType, 'error')(e));
  }
}

function* labLocationsSagas() {
  const serviceType = 'labLocations';
  yield takeEvery(createServiceAction(serviceType, 'requested').type, listener, serviceType);
}

export default labLocationsSagas;
